<template>
  <div>
    <el-tooltip content="返回" placement="top">
      <el-button  v-if="showPrevBtn" @click="goback" icon="el-icon-back" circle></el-button>
    </el-tooltip>
    <el-descriptions title="" v-if="ojdtData" style="margin-bottom: 20px;margin-top: 5px" :column="3" border direction="vertical" size="medium">
      <el-descriptions-item label="凭证字号" >{{ojdtData.accountCode}}</el-descriptions-item>
      <el-descriptions-item label="期间">{{ojdtData.tbperd}}</el-descriptions-item>
      <el-descriptions-item label="状态">
        <DictTag :options="dropDown.ojdtStatus" :value="ojdtData.documentstatus"/>
      </el-descriptions-item>
    </el-descriptions>

    <el-table
      :data="ojdtacctList"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
    >
      <el-table-column prop="remarks" label="摘要" show-overflow-tooltip></el-table-column>
      <el-table-column prop="acctName" label="会计科目">
        <template slot-scope="scope">
          <div v-if="scope.row.changeit == 'Y'" class="link" @click="changeAcct(scope.row, scope.$index)">{{scope.row.acctName}}</div>
          <div v-else>{{scope.row.acctName}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="debit" label="借方金额" align="right" width="150">
        <template slot-scope="scope">
          {{scope.row.debit | comdify('no')}}
        </template>
      </el-table-column>
      <el-table-column prop="credit" label="贷方金额" align="right" width="150">
        <template slot-scope="scope">
          {{scope.row.credit | comdify('no')}}
        </template>
      </el-table-column>
    </el-table>

    <el-dialog v-dialog-drag
      title="核销"
      :visible.sync="dialogFormVisible"
      append-to-body
      width="30%" >
      <el-select v-model="subjectId" placeholder="请选择科目" style="width:100%" filterable @change="changeSubject">
        <el-option v-for="(item, index) in subjectList" :key="index" :value="item.cbSubjectId" :label="item.subjectName">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading" >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url'
import DictTag from "@/components/DictTag.vue";
import {mapState} from "vuex";
  export default {
    components: {DictTag},
    props: {
      ojdtacctList: Array,
      ojdtData: Object
    },
    data() {
      return {
        dialogFormVisible: false,
        subjectList: [],
        subjectId: '',
        isLoading: false,
        offOjdtacctId: '',
        index: 0,
        showPrevBtn : false
      }
    },
    computed: {
      ...mapState({
        dropDown: (state) => state.dropDown.dropDown
      }),
    },
    created() {
      console.log('完整的上个路由对象:', this.$route.meta.fromRoute)
      let path = this.$route.meta.fromRoute.path
      if(path && path.indexOf("accounting") >= 0){
        this.showPrevBtn = true
      }
      // 获取凭证状态下拉
      if(!this.dropDown.ojdtStatus){
        this.$http.get(url.getDataList, {params: {type: 'buss_ojdt_status'}}).then(res => {
          if(res.data.code == 200) {
            this.$store.commit('setOjdtStatus', res.data.data)
          }
        })
      }
    },
    methods: {
      changeAcct(row, index) {
        this.dialogFormVisible = true
        this.subjectId = ''
        this.offOjdtacctId = row.offOjdtacctId
        this.index = index
        this.$http.get(url.getChildSubject + row.offOjdtacctId).then(res => {
          if(res.data.code == 200) {
            console.log(res);

            this.subjectList = res.data.data
          }
        })
      },
      goback(){
        this.$router.go(-1)
      },
      submitForm() {
        if(this.subjectId) {
          this.isLoading = true
          this.$http.post(url.changeOffOjdtacctSubject + this.offOjdtacctId + '/' + this.subjectId).then(res => {
            this.isLoading = false
            if(res.data.code == 200) {
              this.$message.success('修改成功')
              this.ojdtacctList[this.index].acctName = this.subjectList.find(item => item.cbSubjectId == this.subjectId).subjectName
              this.dialogFormVisible = false
            }
          })
        }else {

        }

      },
      changeSubject(e) {
        // console.log(e);


        // this.subjectList.forEach(item => )
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
